<template>
  <div>
    <swiper ref="mySwiper" :options="swiperOptions" class="swiper_con" v-if="row.swiper.length > 0">
      <!-- <swiper-slide v-for="(item, index) in pageDataArr" :key="index">
        <img :src="item.pics[0].url" :data-id="item.id" />
      </swiper-slide> -->
      <swiper-slide v-for="(item, index) in row.swiper" :key="item.id">
        <img :src="item.pic_url" v-rblink="{ name: 'CmsDetail', query: { id: item.id } }"/>
      </swiper-slide>
      <!--      <swiper-slide>-->
      <!--        <img src="~@/assets/images/mainindex/banner@2x.png" />-->
      <!--      </swiper-slide>-->
      <!--      <swiper-slide>-->
      <!--        <img src="~@/assets/images/mainindex/banner@2x.png" />-->
      <!--      </swiper-slide>-->
      <div class="swiper-pagination" slot="pagination"></div>
      　　
      <div class="swiper-button-prev" slot="button-prev" @click="prevFun()">
        <div class="but_direct">
          <i class="el-icon-arrow-left"></i>
        </div>
      </div>
      <div class="swiper-button-next" slot="button-next" @click="nextFun()">
        <div class="but_direct">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </swiper>
    <!-- 申报 -->
    <div class="certificate container_wrap">
      <div class="title_and_subtitle">
        <div class="title_and_subtitle_title">
          <p>业务申报</p>
          <img src="~@/assets/images/mainindex/icon-service-bg.png" alt=""/>
        </div>
        <div class="title_and_subtitle_subtitle">啦啦操各项业务申报</div>
      </div>
      
      <div class="func-row-box">
        <div class="func-row-li" v-for="item in funcList" :key="item.key" @click="toFunc(item)">
          <div class="func-row-img">
            <img :src="item.pic" alt="">
          </div>
          <div class="func-row-tip" v-html="item.name"></div>
        </div>

      </div>


    </div>

    <!-- 通知公告 -->
    <div class="notice container_wrap">
      <div class="title_and_subtitle">
        <div class="title_and_subtitle_title">
          <p>通知公告</p>
          <img src="~@/assets/images/mainindex/icon-notice-bg@2x.png" alt=""/>
        </div>
        <div class="title_and_subtitle_subtitle">
          赛事、培训、活动等官方权威发布
        </div>
      </div>
      <div class="notice_content">
        <div class="notice_content_left">
          <div
              class="notice_content_left_item"
              v-for="(item, index) in row.notice.slice(0, 4)"
              :key="item.id"
              v-rblink="{ name: 'CmsDetail', query: { id: item.id } }"
          >
            <img :src="item.pic_url"/>
            <div class="notice_content_left_item_desc">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="notice_content_right">
          <div class="notice_content_right_up">
            <div
                class="notice_content_right_up_desc"
                v-for="(item, index) in row.notice.slice(4, 5)"
                :key="item.id"
                v-rblink="{ name: 'CmsDetail', query: { id: item.id } }"
            >
              <div class="notice_content_right_up_desc_title">
                {{ item.title }}
              </div>
              <div class="notice_content_right_up_desc_fonts">
                {{ item.desc }}
              </div>
              <div class="notice_content_right_up_desc_items">
                <div class="notice_content_right_up_desc_items_details">
                  查看详情
                  <i class="el-icon-right"></i>
                </div>
                <div class="notice_content_right_up_desc_items_date">
                  {{ item.create_time | formatDate }}
                </div>
              </div>
            </div>
            <div v-for="(item, index) in row.notice.slice(5, 6)"
                 :key="item.id"
                 v-rblink="{ name: 'CmsDetail', query: { id: item.id } }"
            >
              <img
                  :src="item.pic_url"
                  alt=""
              />
            </div>
          </div>
          <div class="notice_content_right_down">
            <div
                class="notice_content_right_down_item"
                v-for="(item, index) in row.notice.slice(6, 11)"
                :key="item.id"
                v-rblink="{ name: 'CmsDetail', query: { id: item.id } }"
            >
              <div class="notice_content_right_down_item_date">
                {{ item.create_time | formatDate }}
              </div>
              <div class="notice_content_right_down_item_title">
                {{ item.title }}
              </div>
            </div>
            <div class="notice_content_right_down_more"  v-rblink="{ name: 'NewsList', query: { cate_id: 13 } }">
              查看更多<i class="el-icon-d-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 新闻资讯 -->
    <div class="news_info container_wrap">
      <div class="title_and_subtitle">
        <div class="title_and_subtitle_title">
          <p>新闻资讯</p>
          <img src="~@/assets/images/mainindex/icon-news-bg@2x.png" alt=""/>
        </div>
        <div class="title_and_subtitle_subtitle">
          CCA最新赛事活动数据风采展示
        </div>
        <div class="title_and_subtitle_subtitle">
          我们累计举办了近2000余场国内外啦啦操赛事，参赛运动员超百万人次
        </div>
      </div>
      <div class="news_info_content">
        <div class="news_info_left" v-for="(item, index) in row.news.slice(0, 1)"
             v-rblink="{ name: 'CmsDetail', query: { id: item.id } }"
             :key="item.id">
          <img :src="item.pic_url" alt=""/>
          <div class="news_info_desc">
            <div class="news_info_desc_title">
              {{ item.title }}
            </div>
            <div class="news_info_desc_subtitle">
              {{ item.desc }}
            </div>
            <div class="news_info_desc_nums">
              <div class="news_info_desc_nums_date"> {{ item.create_time | formatDate }}</div>
              <div class="news_info_desc_nums_fire">{{ item.views_count }}</div>
            </div>
            <div class="news_info_desc_jump"></div>
          </div>
        </div>
        <div class="news_info_right">
          <div
              class="news_info_right_items"
              v-for="(item, index) in row.news.slice(1,10)"
              :key="item.id"
              v-rblink="{ name: 'CmsDetail', query: { id: item.id } }"
          >
            <div class="news_info_right_item">
              <img :src="item.pic_url" alt=""/>
              <div class="news_info_right_item_date">{{ item.create_time | formatDate }}</div>
              <div class="news_info_right_item_title">
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="news_info_right_items" v-rblink="{ name: 'NewsList', query: { cate_id: 12 } }">
            <!-- <div class="news_info_right_item_last_count">{{ this.news_2.length }}<sup>+</sup></div> -->
            <div class="news_info_right_item_last_count">9999<sup>+</sup></div>
            <div class="news_info_right_item_last_more">
              更多精彩<i class="el-icon-d-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 技术课程 -->
    <div class="courses container_wrap">
      <div class="title_and_subtitle">
        <div class="title_and_subtitle_title">
          <p>啦啦操课程</p>
          <img src="~@/assets/images/mainindex/icon-course-bg@2x.png" alt=""/>
        </div>
        <div class="title_and_subtitle_subtitle">CCA线上教育教学</div>
      </div>
      <div class="course_list">
        <div
            class="course_list_item"
            v-for="(item, index) in row.course"
            :key="item.id"
            v-rblink="{ name: 'CourseDetail', query: { id: item.id } }"
        >
          <div class="courseitem">
            <img width="100%" :src="item.pic_url" alt=""/>
            <span v-if="item.level">{{ item.level }}</span>
            <div class="course-title show-one-row">{{ item.title }}</div>
            <div class="courseitem_desc">
              <div class="courseitem_desc_person">
                {{ item.views_count }}人学习
              </div>
              <div v-if="false" class="courseitem_desc_money">{{ item.price }}</div>
            </div>
          </div>
        </div>

        <div class="course_content_right_down_more"  v-rblink="{ name: 'CourseList', query: {} }">
          查看更多<i class="el-icon-d-arrow-right"></i>
        </div>
      </div>

    </div>


    <!-- 证书 -->
    <div class="certificate container_wrap">
      <div class="title_and_subtitle">
        <div class="title_and_subtitle_title">
          <p>证书展示</p>
          <img src="~@/assets/images/mainindex/icon-certificate-bg.png" alt=""/>
        </div>
        <div class="title_and_subtitle_subtitle">啦啦操各类证书展示</div>
      </div>
      <div class="cert_list">
        <div
            class="cert_list_item"
            v-for="(item, index) in row.cert"
            :key="item.id"
            
        >
          <div class="certitem">
            <img width="100%" :src="item.pic_url" alt=""/> 
          </div>
            <div class="cert-title show-one-row">{{ item.title }}</div> 
        </div>
 
      </div>

    </div>





  </div>
</template>
<script>
import {formatDate} from "../../utils/date";
import CourseItem from "@/components/mainindex/CourseItem";

export default {
  name: "IndexPc",
  data() {
    return {
      notic_1: [],
      notic_2: [],
      notic_3: [],
      notic_4: [],
      news_1: [],
      news_2: [],
      course: [],
      swiperOptions: {
        loop: true, // 无限循环
        slidesPerView: 1.2,
        autoplayDisableOnInteraction: false,
        autoplay: 3000,
        preventLinksPropagation: false,
        on: {
          click: (v) => {
            // const id = v.target.getAttribute("data-id");
            // this.bannerClickFun(id);
          },
        },
        pagination: ".swiper-pagination",
        // paginationType: "custom",
        // paginationCustomRender: function (swiper, current, total) {
        //   var paginationHtml = "";
        //   for (var i = 0; i < total; i++) { // 判断是不是激活焦点，是的话添加active类，不是就只添加基本样式类
        //     if (i === current - 1) {
        //       paginationHtml =
        //         '<span class="swiper-pagination-customs swiper-pagination-customs-active"></span>';
        //     }
        //     paginationHtml = '<span class="swiper-pagination-customs"></span>';
        //   }
        //   return paginationHtml;
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        centeredSlides: true,
        loopAdditionalSlides: 100,
        spaceBetween: 0,
      },

      funcList: [
        {name: '赛事活动', pic: require("../../assets/images/mine/icon-saishihuodong@2x.png"), key: "sai"},
        {name: "全国啦啦操<br>科学论文报告会投稿", pic: require("../../assets/images/mine/icon-julebu@2x.png"), key: "club"},
        {name: '培训会议', pic: require("../../assets/images/mine/icon-huiyi@2x.png"), key: "huiyi"},
        {name: '大课间', pic: require("../../assets/images/mine/icon-dakejian@2x.png"), key: "dakejian"},
        {name: '运动员等级', pic: require("../../assets/images/mine/icon-sihaoyundongyaun@2x.png"), key: "sihao"},
      ],
      row: {
        swiper: [],
        notice: [],
        news: [],
        course: [],
        cert: [],
      }
    };
  },
  mounted() {
    // this.getnotice();
    // this.getcourse();

    document.title = "中国蹦床与技巧协会啦啦操分会官方 啦啦操官方网站"
    document.querySelector('meta[name="description"]').setAttribute('content','中国蹦床与技巧协会啦啦操分会（CCA）是在国家体育总局体操运动管理中心和中国蹦床与技巧协会的指导和监督下，负责管理全国啦啦操项目的唯一机构。')
    this.getData();
  },
  filters: {
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, " M-d ");
    },
  },
  methods: {

    // 功能跳转
    toFunc(item) {
      let name = ''
      switch (item.key) {
        case 'sai':
          name = "SaiDateList"
          break;
        case 'huiyi':
          name = "HuiyiList"
          // this.$message.warning("即将开放~")
          // return ;
          break;
        case 'club':
          window.open('http://www.ccachina.net/lunwen_profile');
          return ;
          name = "ClubIndex"
          this.$message.warning("即将开放~")
          return ;
          break;
        case 'dakejian':
          name = "DakejianList"
          // this.$message.warning("即将开放~")
          // return ;
          break;
        case 'sihao':
          name = "PageYundongyuandengji"
          // this.$message.warning("即将开放~")
          // return ;
          break;
        default:
          this.$message.warning("正在建设中哦~")
          // this.centerDialogVisible = true
      }
      if (!name) return
      this.$router.push({
        name: name
      })
    },
    getData() {
      let that = this;
      this.$api.get(
          "/api/index/pcIndexData",
          this.params,
          (res) => {
            that.row = res.data
          },
          (res) => {
            that.$message.error(res.msg);
          }
      );
    },

    getnotice() {
      const that = this;
      that.$api.get(
          "/api/cms/recommendList",
          {
            cate_ids: 90,
          },
          (res) => {
            this.notic_1 = res.data;
          }
      );
      that.$api.get(
          "/api/cms/recommendList",
          {
            cate_ids: 91,
          },
          (res) => {
            this.notic_2 = res.data;
          }
      );
      that.$api.get(
          "/api/cms/recommendList",
          {
            cate_ids: 92,
          },
          (res) => {
            this.notic_3 = res.data;
          }
      );
      that.$api.get(
          "/api/cms/recommendList",
          {
            cate_ids: 93,
          },
          (res) => {
            this.notic_4 = res.data;
          }
      );
      that.$api.get(
          "/api/cms/recommendList",
          {
            cate_ids: 94,
          },
          (res) => {
            this.news_1 = res.data;
          }
      );
      that.$api.get(
          "/api/cms/recommendList",
          {
            cate_ids: 95,
          },
          (res) => {
            this.news_2 = res.data;
          }
      );
    },
    getcourse() {
      let that = this;
      this.$api.get(
          "/api/course/courseList",
          this.params,
          (res) => {
            that.loading = false;
            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.course = res.data.list;
            } else {
              that.course = that.course.concat(res.data.list);
            }

            if (res.data.list.length == 0) {
              that.finished = true;
            }
          },
          (res) => {
            Toast(res.msg);
          }
      );
    },
    prevFun() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    nextFun() {
      this.$refs.mySwiper.swiper.slideNext();
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  components: {
    CourseItem,
  },
};
</script>
<style lang="scss" scoped>
.container_wrap {
  width: 1200px;
  margin: 0 auto;
}

.swiper_con {
  --swiper-theme-color: #ff6600;
  --swiper-pagination-color: #fb4831;
  //height: 470px;
  // width: 38.125rem;
  /deep/ .swiper-slide-next,
  /deep/ .swiper-slide-prev {
    padding: 18px 0;
    box-sizing: border-box;
  }

  .swiper-pagination-bullets {
    bottom: 60px;
  }

  .swiper-button-prev,
  .swiper-button-next {
    font-size: 20px;
    width: 66px;

    &::after {
      content: "";
    }
  }

  img {
    width: 100%;
    //height: 100%;
    cursor: pointer;
  }

  .but_direct {
    color: #ffffff;
    width: 66px;
    height: 66px;
    line-height: 66px;
    text-align: center;
    border-radius: 33px;
    background: rgba(0, 0, 0, 0.3);
    transition: all 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.6);
    }
  }
}

.title_and_subtitle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 76px 0 30px 0;
  text-align: center;

  .title_and_subtitle_title {
    width: 286px;
    height: 51px;
    position: relative;

    p {
      font-size: 32px;
      font-weight: 600;
      color: #333333;
      //padding-left: 57px;
    }

    img {
      position: absolute;
      bottom: 0;
      width: 286px;
      height: 33px;
      right: -20px;
    }
  }

  .title_and_subtitle_subtitle {
    max-width: 1200px;
    margin-top: 7px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
  }
}

.notice {
  .notice_content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .notice_content_left {
      width: 452px;
      height: 415px;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-right: 17px;

      .notice_content_left_item {
        position: relative;
        width: 220px;
        height: 200px;
        transition: all 0.5s;
        margin-bottom: 15px;

        &:hover {
          transform: scale(1.05);
          cursor: pointer;
        }

        img {
          width: 220px;
          height: 200px;
          object-fit: cover;
          overflow: hidden;
        }

        .notice_content_left_item_desc {
          position: absolute;
          bottom: 0;
          width: 100%;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
          padding: 0 10px 8px 10px;
          box-sizing: border-box;
          background: #000;
          background: linear-gradient(rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 1));
        }
      }
    }

    .notice_content_right {
      width: 731px;
      height: 415px;
      background: #ffffff;
      box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      padding: 12px 19px 7px 14px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .notice_content_right_up {
        border-bottom: 1px solid #f4f4f4;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        box-sizing: border-box;
        padding-bottom: 25px;

        .notice_content_right_up_desc {
          flex: 1;
          width: 467px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          cursor: pointer;
          //   margin-bottom: 29px;
          .notice_content_right_up_desc_title {
            width: 438px;
            font-size: 18px;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.7);
            line-height: 25px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .notice_content_right_up_desc_fonts {
            width: 402px;
            height: 40px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .notice_content_right_up_desc_items {
            width: 467px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .notice_content_right_up_desc_items_details {
              color: #666666;

              .el-icon-right {
                color: #999999;
              }

              &:hover {
                cursor: pointer;
                font-weight: bold;
              }
            }

            .notice_content_right_up_desc_items_date {
              color: rgba(0, 0, 0, 0.7);
            }
          }
        }

        img {
          width: 172px;
          height: 162px;
          object-fit: cover;
          cursor: pointer;
        }
      }

      .notice_content_right_down {
        position: relative;
        flex: 1;
        padding-top: 27px;
        box-sizing: border-box;

        .notice_content_right_down_item {
          display: flex;
          flex-direction: row;
          margin-bottom: 20px;

          &:hover {
            cursor: pointer;
            font-weight: bold;

            .notice_content_right_down_item_title {
              font-weight: bold;
            }
          }

          .notice_content_right_down_item_date {
            width: 50px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            background: #aaaaaa;
            border-radius: 10px 10px 0px 10px;
            margin-right: 13px;
          }

          .notice_content_right_down_item_title {
            height: 20px;
            line-height: 20px;
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .notice_content_right_down_more {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          font-size: 12px;
          font-weight: 400;
          color: rgba(102, 102, 102, 0.6);

          &:hover {
            font-weight: bold;
            cursor: pointer;

            .el-icon-d-arrow-right {
              color: rgba(102, 102, 102, 0.6);
            }
          }

          .el-icon-d-arrow-right {
            transform: rotate(90deg);
            color: #e6e6e6;
          }
        }
      }
    }
  }
}

.courseitem {
  position: relative;
  width: 290px;
  height: 242px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  box-sizing: border-box;
  overflow: hidden;
  transition: all 0.3s;

  .course-title {
    margin: 10px 0;
    text-align: center;
  }

    img{
      max-height: 159px;
    object-fit: cover;
    vertical-align: middle;
    }
}


.certitem { 
  width: 200px;
  height: 260px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  justify-content:center;
  align-items:center;
  box-sizing: border-box;
  overflow: hidden;
  transition: all 0.3s; 
  display: table-cell;
    vertical-align: middle;

}


  .cert-title {
    margin: 10px 0;
    text-align: center;
  }

.news_info {
  .title_and_subtitle {
    padding-bottom: 10px;
  }

  .news_info_content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 848px;

    .news_info_left {
      width: 736px;
      height: 848px;
      position: relative;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;

      img {
        width: 736px;
        height: 848px;
        object-fit: cover;
      }

      .news_info_desc {
        height: 160px;
        width: 100%;
        position: absolute;
        bottom: 0;
        background: linear-gradient(rgba(0, 0, 0, 0.49), rgba(0, 0, 0, 0.49));
        padding: 26px 40px 24px 20px;
        box-sizing: border-box;

        .news_info_desc_title {
          font-size: 20px;
          font-weight: 500;
          color: #ffffff;
          line-height: 28px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .news_info_desc_subtitle {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;

          height: 40px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.5);
          line-height: 20px;
          margin: 11px 0;
        }

        .news_info_desc_nums {
          height: 21px;
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          line-height: 21px;
          display: flex;
          flex-direction: row;

          .news_info_desc_nums_date {
            margin-right: 28px;
            position: relative;
            padding-left: 33px;

            &::before {
              content: "";
              display: block;
              width: 22px;
              height: 21px;
              left: 0px;
              position: absolute;
              background: url("~@/assets/images/mainindex/icon-calendar@2x.png") center center no-repeat;
              background-size: 100% 100%;
            }
          }

          .news_info_desc_nums_fire {
            position: relative;
            padding-left: 23px;

            &::before {
              content: "";
              display: block;
              width: 16px;
              height: 21px;
              left: 0px;
              position: absolute;
              background: url("~@/assets/images/mainindex/jianshen-huoyan-reqing-xihuan.png") center center no-repeat;
              background-size: 100% 100%;
            }
          }
        }

        .news_info_desc_jump {
          position: absolute;
          bottom: 21px;
          right: 40px;
          width: 43px;
          height: 43px;
          background: url("~@/assets/images/mainindex/icon-news-viewmore@2x.png") center center no-repeat;
          background-size: 100% 100%;

          &:hover {
            cursor: pointer;
            opacity: 0.8;
          }
        }
      }
    }

    .news_info_right {
      width: 452px;
      height: 848px;
      box-sizing: border-box;

      .news_info_right_items {
        display: inline-block;
        width: 220px;
        height: 160px;
        box-sizing: border-box;
        margin-bottom: 8px;
        border-radius: 3px;
        overflow: hidden;

        &:nth-child(2n + 1) {
          margin-right: 12px;
        }

        &:nth-last-child(2) {
          margin-bottom: 0;
          margin-right: 8px;
        }

        &:last-child {
          margin-bottom: 0;
          background: #3b8de3;
          position: relative;
          transition: all 1s;

          &:hover {
            .news_info_right_item_last_count {
              opacity: 0.8;
            }

            .news_info_right_item_last_more {
              font-weight: bold;
            }

            .el-icon-d-arrow-right {
              font-weight: bold;
            }
          }

          .news_info_right_item_last_count {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 50px;
            font-weight: 500;
            color: #ffffff;
          }

          .news_info_right_item_last_more {
            position: absolute;
            bottom: 8px;
            left: 11px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            transition: all 0.5s;

            .el-icon-d-arrow-right {
              margin-left: 5px;
            }
          }
        }

        &:hover {
          transition: all 0.6s;
          cursor: pointer;

          img {
            transform: scale(1.05);
          }
        }

        .news_info_right_item {
          width: 220px;
          height: 160px;
          position: relative;
          background: rgba(0, 0, 0, 0.5);
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          img {
            width: 220px;
            height: 160px;
            object-fit: cover;
            position: absolute;
            z-index: -1;
            transition: all 0.3s;
          }

          .news_info_right_item_date {
            margin-left: 11px;
            margin-top: 15px;
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
          }

          .news_info_right_item_title {
            width: 198px;
            height: 44px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-left: 11px;
            margin-bottom: 14px;
          }
        }
      }
    }
  }
}

.course_list {
  margin-bottom: 60px;
  position: relative;

  .course_content_right_down_more {
    position: absolute;
    //bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 0.6);

    &:hover {
      font-weight: bold;
      cursor: pointer;

      .el-icon-d-arrow-right {
        color: rgba(102, 102, 102, 0.6);
      }
    }

    .el-icon-d-arrow-right {
      transform: rotate(90deg);
      color: #e6e6e6;
    }
  }

  .course_list_item {
    margin-right: 13px;
    margin-bottom: 13px;
    display: inline-block;
    box-sizing: border-box;
    cursor: pointer;

    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}

.courseitem_desc_money {
  height: 32px;
  font-weight: 400;
  font-size: 20px;
  color: #fa6400;
  line-height: 32px;
  position: relative;

  &::before {
    content: "￥";
    color: #fa6400;
    font-size: 16px;
    position: absolute;
    left: -11px;
    bottom: -1px;
  }
}

.courseitem_desc_person {
  height: 32px;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 32px;
}

.courseitem_desc {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 8px;
}


.cert_list {
  margin-bottom: 60px;

  display: flex;
  flex-wrap:wrap; 
  justify-content:space-between;
 
  .cert_list_item { 
    display: inline-block;
    box-sizing: border-box;
    cursor: pointer;
 
      img {
        transition: all 0.6s;
      }
      &:hover {
        img {
          transform: scale(1.2);
        }
      }
  }

}

.courseitem_desc_money {
  height: 32px;
  font-weight: 400;
  font-size: 20px;
  color: #fa6400;
  line-height: 32px;
  position: relative;

  &::before {
    content: "￥";
    color: #fa6400;
    font-size: 16px;
    position: absolute;
    left: -11px;
    bottom: -1px;
  }
}


.func-row-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;

  .func-row-li {
    margin-right: 48px;
    text-align: center;
    cursor: pointer;

    .func-row-img {
      img {
        width: 60px;
        height: 60px;
      }
    }

    .func-row-tip {
      font-weight: 400;
      color: #333333;
      font-size: 16px;
      margin-top: 10px;
    }

  }
}

</style>



// WEBPACK FOOTER //
// IndexPc.vue?c69a8278